export default {
  // addOdd ({commit, state}, val) {
  //   if (state.sum % 2 !== 0) {
  //     commit('add', val)
  //   }
  // },
  // addWait ({commit}, val) {
  //   setTimeout(() => {
  //     commit('add', val)
  //   }, 1000)
  // },
  dispatchEditor ({ commit }, value) {
    commit('SET_EDITOR_TITLE', value)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js